import React from 'react';
import Style from './index.less';
import classNames from 'classnames';
import * as ICON from './preset-icons';

import {
    GlowPresetStyleList,
    EffectPropsField,
    DefaultEffectPresetProps,
} from '@src/framework/editor/src/js/constants';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import * as TextIcon from '@com-pc/palette-panel/effect-preset-menu/glow-preset-menu/preset-icons/index-text';
import ImageQuickLookManager
    from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-quick-look-manager';
import { TDColor, opacityToAlpha } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

const defaultGlowProps = {
    ...DefaultEffectPresetProps[ActionType.GLOW],
    [EffectPropsField.SIZE.name]: 5,
    [EffectPropsField.COLOR.name]: '#0E0E0E',
};

// 每次获取的时候实时创建对象，否则会出现原始对象被修改而导致一些 bug：http://tapd.oa.com/TIM_web/bugtrace/bugs/view/1010143861096093443
const glowStyleAndPropsMappingCreator = () => ({
    'glow-empty-click': null,
    'glow-empty-hover': { ...defaultGlowProps, [EffectPropsField.OPACITY.name]: 0, [EffectPropsField.SIZE.name]: 0 },
    'glow-1': { ...defaultGlowProps, [EffectPropsField.COLOR.name]: '#000000', [EffectPropsField.TD_COLOR.name]: new TDColor({ rgbaStr: '#000000', alpha: opacityToAlpha(60) }) },
    'glow-2': { ...defaultGlowProps, [EffectPropsField.COLOR.name]: '#F64848', [EffectPropsField.TD_COLOR.name]: new TDColor({ rgbaStr: '#F64848', alpha: opacityToAlpha(60) }) },
    'glow-3': { ...defaultGlowProps, [EffectPropsField.COLOR.name]: '#FFE59A', [EffectPropsField.TD_COLOR.name]: new TDColor({ rgbaStr: '#FFE59A', alpha: opacityToAlpha(60) }) },
    'glow-4': { ...defaultGlowProps, [EffectPropsField.COLOR.name]: '#FDE525', [EffectPropsField.TD_COLOR.name]: new TDColor({ rgbaStr: '#FDE525', alpha: opacityToAlpha(60) }) },
    'glow-5': { ...defaultGlowProps, [EffectPropsField.COLOR.name]: '#B2E922', [EffectPropsField.TD_COLOR.name]: new TDColor({ rgbaStr: '#B2E922', alpha: opacityToAlpha(60) }) },
    'glow-6': { ...defaultGlowProps, [EffectPropsField.COLOR.name]: '#D041E1', [EffectPropsField.TD_COLOR.name]: new TDColor({ rgbaStr: '#D041E1', alpha: opacityToAlpha(60) }) },
    'glow-7': { ...defaultGlowProps, [EffectPropsField.COLOR.name]: '#A98DFD', [EffectPropsField.TD_COLOR.name]: new TDColor({ rgbaStr: '#A98DFD', alpha: opacityToAlpha(60) }) },
    'glow-8': { ...defaultGlowProps, [EffectPropsField.COLOR.name]: '#547CF8', [EffectPropsField.TD_COLOR.name]: new TDColor({ rgbaStr: '#547CF8', alpha: opacityToAlpha(60) }) },
    'glow-9': { ...defaultGlowProps, [EffectPropsField.COLOR.name]: '#03C3FF', [EffectPropsField.TD_COLOR.name]: new TDColor({ rgbaStr: '#03C3FF', alpha: opacityToAlpha(60) }) },
});

const TextIconMapping = {
    'glow-1': TextIcon.DrawerGlow1,
    'glow-2': TextIcon.DrawerGlow2,
    'glow-3': TextIcon.DrawerGlow3,
    'glow-4': TextIcon.DrawerGlow4,
    'glow-5': TextIcon.DrawerGlow5,
    'glow-6': TextIcon.DrawerGlow6,
    'glow-7': TextIcon.DrawerGlow7,
    'glow-8': TextIcon.DrawerGlow8,
    'glow-9': TextIcon.DrawerGlow9,
};

interface GlowPresetMenuProps {
    onGlowPresetStyleMouseEnter: (value) => void;
    onGlowPresetStyleClick: (value) => void;
    onGlowPresetStyleMouseLeave: () => void;
    preset: any;
    id?: string;
    style?: React.CSSProperties;
}

export default class GlowPresetMenu extends React.Component<GlowPresetMenuProps> {
    public static PresetIconOnShow = {
        'glow-empty': ICON.DrawerEMPTY,
        'glow-1': ICON.DrawerGlow1,
        'glow-2': ICON.DrawerGlow2,
        'glow-3': ICON.DrawerGlow3,
        'glow-4': ICON.DrawerGlow4,
        'glow-5': ICON.DrawerGlow5,
        'glow-6': ICON.DrawerGlow6,
        'glow-7': ICON.DrawerGlow7,
        'glow-8': ICON.DrawerGlow8,
        'glow-9': ICON.DrawerGlow9,
    };
    public static defaultProps = {};

    private glowPresetDropList;
    public constructor(props, context) {
        super(props, context);
        this.glowPresetDropList = [];
        for (let i = 0, len = GlowPresetStyleList.length; i < len; i++) {
            const item = GlowPresetStyleList[i];
            this.glowPresetDropList.push({
                ...item,
                // icon: GlowPresetIconList[i],
                isSelected: item.style === this.props.preset.style,
            });
        }
    }

    public render() {
        return (
            <div
                className={classNames([Style.container, Style['container-text']])}
                style={{
                    ...this.props.style,
                }}
            >
                <div className={Style['no-glow-title']}
                    onClick={() => this.handleGlowPresetIconClick('glow-empty-click')}
                    onMouseEnter={() => this.handleGlowPresetIconMouseEnter('glow-empty-hover')}
                    onMouseLeave={() => this.handleGlowPresetIconMouseLeave()}
                >
                    <span>{i18n.t('无效果')}</span>
                </div>
                <div className={Style['glow-type-title']}>{i18n.t('发光')}</div>
                <div className={Style['glow-collection']}>
                    {
                        this.glowPresetDropList.map((item) => {
                            const shadowItemClass = classNames({
                                [Style['glow-collection-item']]: true,
                                [Style['glow-item-selected']]: item.isSelected,
                            });
                            return (
                                <div key={item.key}
                                    className={shadowItemClass}
                                    onMouseEnter={() => {
                                        this.handleGlowPresetIconMouseEnter(item.style);
                                    }}
                                    onClick={() => {
                                        this.handleGlowPresetIconClick(item.style);
                                    }}
                                    onMouseLeave={() => {
                                        this.handleGlowPresetIconMouseLeave();
                                    }}>
                                    {/* <img src={item.icon}></img> */}
                                    <div className={Style['glow-item-img']}>
                                        <img
                                            src={ImageQuickLookManager
                                                .getInstance()
                                                .getDisplayUrl(TextIconMapping[item.style])}
                                            style={{
                                                width: '50px',
                                                height: 'auto',
                                            }}
                                        />
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }

    private handleGlowPresetIconMouseEnter = (style) => {
        const value = glowStyleAndPropsMappingCreator()[style];
        this.props.onGlowPresetStyleMouseEnter(value ? { ...value } : value);
    };

    private handleGlowPresetIconClick = (style) => {
        const value = glowStyleAndPropsMappingCreator()[style];
        this.props.onGlowPresetStyleClick(value ? { ...value } : value);
    };

    private handleGlowPresetIconMouseLeave = () => {
        this.props.onGlowPresetStyleMouseLeave();
    };
}
